import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { positionConstants } from '../../utilities/Constants';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  standalone: false,
    selector: 'mm-table-text',
    templateUrl: './table-text-field.component.html',
    styleUrls: ['./table-text-field.component.scss']
})
export class TextFieldComponent implements ICellRendererAngularComp {
    public cellValue: string;
    public toolTipError: string;
    public showToolTip: boolean;
    public isRestricted: boolean;
    position: TooltipPosition = 'after';
    quantityMismatch: string = positionConstants.positionMismatchRestriction;


    ngOnInit(): void {}
    
    agInit(params: ICellRendererParams): void {
        this.displayText(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.displayText(params);
        return true;
    }

    displayText(params: ICellRendererParams) {
        this.toolTipError = '';
        this.cellValue = '';
        this.showToolTip = false;
        this.isRestricted = false
        if (params.data.restrictions.isRestricted) {
            this.isRestricted = true;
            if (params.data.restrictions.restrictionText === this.quantityMismatch) {
                this.cellValue = "Quantity Mismatch";
                this.toolTipError = this.quantityMismatch;
                this.showToolTip = true;
            }
            else {
                this.cellValue = params.data.restrictions.restrictionText;
            }
        }
        else {
            this.cellValue = params.value;
        }
    }
}